import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import UrlDocumentContext from 'features/urlDocumentScreens/UrlDocumentContext/UrlDocumentContext';
import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import WebView from 'react-native-webview';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';
import { webViewAdditionalProps } from 'shared/utils/webView/webViewAdditionalProps';

const HtmlDocumentScreen = () => {
  const { documentHtml } = useContext(UrlDocumentContext);
  const router = useRouter();
  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  const { bottom } = useSafeAreaInsets();

  return (
    <View style={[styles.container, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: '',
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      {documentHtml ? (
        <WebView
          {...webViewAdditionalProps}
          originWhitelist={['*']}
          source={{ html: documentHtml }}
          style={styles.webView}
        />
      ) : (
        <View style={styles.errorContainer}>
          <ErrorScreen
            screenType={ErrorScreenType.Error}
            messageHeadline={defaultTitle}
            messageBody={defaultMessage}
            insetBottomSafeArea={false}
            primaryButton={{
              title: cancelButtonTitle,
              onPress: () => {
                if (router.canGoBack()) {
                  router.back();
                }
              },
            }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.color.background.primary,
  },
  errorContainer: {
    flex: 1,
    padding: theme.spacing.m,
  },
  webView: {
    backgroundColor: theme.color.background.primary,
  },
});

export default HtmlDocumentScreen;
